import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import StyledTextField from '../Shared/StyledTextField';

const OneLineTextFieldComponent = (props) => {
  const {
    input,
    meta: { touched, error },
    disabled,
    label,
    ...custom
  } = props;
  return (
    <Box display="flex" alignItems="center">
      <StyledTextField
        helperText={touched && error}
        error={touched && !!error}
        disabled={!!disabled}
        {...input}
        {...custom}
        sx={{ maxWidth: '10rem' }}
      />
      <Box ml="1rem" />
      <Typography>{label}</Typography>
    </Box>
  );
};
OneLineTextFieldComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

export default OneLineTextFieldComponent;
